import React from 'react';
import styles from './Support.module.css';
import { useDocumentHead } from '../../hooks/useDocumentHead';

const Support = () => {
  useDocumentHead(
    'Support & Expert Team | TopSpeaks',
    'Meet our expert team of speaking coaches and get professional support. Access technical assistance and resources to enhance your speaking skills.',
    'index, follow'
  );
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <header className={styles.header}>
          <h1>Support & Resources</h1>
          <p className={styles.headerSubtext}>Get assistance and meet our team of experts</p>
        </header>

        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Leadership Team</h2>
            <p>The driving force behind TopSpeaks</p>
          </div>

          <div className={styles.teamGrid}>
            <div className={styles.teamMember}>
              <div className={styles.memberContent}>
                <h3>M. Saad Arif Dhillon</h3>
                <span className={styles.role}>Founder & CEO</span>
                <p>Software Engineer and entrepreneur passionate about leveraging AI to
                  enhance public speaking skills. Vision, strategy, and innovation behind
                  TopSpeaks' growth and success. <span><a href="mailto:saadaryf@gmail.com" className={styles.email}>
                    saadaryf@gmail.com
                  </a></span>
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>Technical Support</h2>
            <p>We're here to help you succeed</p>
          </div>

          <div className={styles.supportContent}>
            <div className={styles.supportCard}>
              <h3>Contact Information</h3>
              <a href="mailto:hello@topspeaks.com" className={styles.emailButton}>
                hello@topspeaks.com
              </a>
              <p className={styles.supportNote}>
                Email response time: Within 24 hours during business days
              </p>
            </div>

            <div className={styles.supportCard}>
              <h3>Business Hours</h3>
              <div className={styles.hoursGrid}>
                <div>
                  <strong>Weekdays</strong>
                  <p>9:00 AM - 5:00 PM (PKT)</p>
                </div>
                <div>
                  <strong>Weekend</strong>
                  <p>Closed</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );

};

export default Support;